module.exports = __webpack_public_path__ + "img/mb_Credit.3c6507b8.svg";